/**
 * Maps user-facing input style names to MUI TextField variant values.
 * "underlined" maps to MUI's "standard" variant.
 *
 * @type {Record<string, string>}
 */
export const INPUT_STYLE_MAP = {
    outlined: 'outlined',
    filled: 'filled',
    underlined: 'standard',
}

/**
 * Applies input field style override from store settings to the theme.
 * Sets the default variant for both MuiTextField and MuiFormControl.
 *
 * @param {import('@mui/material/styles').Theme} theme - The base MUI theme
 * @param {Object|null} storeSettings - Store customization settings
 * @returns {Object} Modified theme options object
 */
export const applyInputOverrides = (theme, storeSettings) => {
    const inputStyle = storeSettings?.webStoreInputStyle
    if (!inputStyle || !(inputStyle in INPUT_STYLE_MAP)) {
        return theme
    }

    const variant = INPUT_STYLE_MAP[inputStyle]

    return {
        ...theme,
        components: {
            ...theme.components,
            MuiTextField: {
                ...theme.components?.MuiTextField,
                defaultProps: {
                    ...theme.components?.MuiTextField?.defaultProps,
                    variant,
                },
            },
            MuiFormControl: {
                ...theme.components?.MuiFormControl,
                defaultProps: {
                    ...theme.components?.MuiFormControl?.defaultProps,
                    variant,
                },
            },
        },
    }
}
